if (!customElements.get('quick-add-drawer-opener')) {
  customElements.define('quick-add-drawer-opener', class QuickAddDrawerOpener extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      this.onClickHandler = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClickHandler);
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.onClickHandler);
    }

    onClick(e) {
      this.button.setAttribute('aria-disabled', true);
      this.button.classList.add('loading');
      this.button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      let url = this.button.dataset.productUrl;
      if(url.includes('?')) {
        url += '&';
      } else {
        url += '?';
      }
      url += 'section_id=quick-add-drawer';
      fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const newQuickAddDrawer = getDomHtmlFromText(responseText, 'quick-add-drawer');
        if(window.hasQuickAddDrawer) {
          const quickAddDrawer = document.querySelector('quick-add-drawer');
          quickAddDrawer.setInnerHTML(newQuickAddDrawer);
          quickAddDrawer.open(this.button);
        } else {
          document.body.appendChild(newQuickAddDrawer);
          HTMLUpdateUtility.reinjectsScripts(document.querySelector('quick-add-drawer'));
          newQuickAddDrawer.runAfterUpdateHtml();
          setTimeout(() => {
            newQuickAddDrawer.open(this.button);
          }, 300);
          window.hasQuickAddDrawer = true;
        }      
      })
      .finally(() => {
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
        this.button.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }
  });
}
if (!customElements.get('quick-add-drawer')) {
  customElements.define('quick-add-drawer', class QuickAddDrawer extends DrawerFixed {
    constructor() {
      super();

      this.querySelector('.drawer__overlay').addEventListener('click', this.close.bind(this));
      this.postProcessHtmlCallbacks = [];
    }

    connectedCallback() {
      this.initializeCallbackUtility();
      this.variantChangeHandler = this.onVariantChanged.bind(this);
      this.addOnPickerVariantChangeHandler = this.onAddOnPickerVariantChanged.bind(this);
      document.addEventListener('afterVariantChanged', this.variantChangeHandler);
      this.addEventListener('addOnPickerVariantChanged', this.addOnPickerVariantChangeHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('afterVariantChanged', this.variantChangeHandler);
      this.removeEventListener('addOnPickerVariantChanged', this.addOnPickerVariantChangeHandler);
    }

    close(evt) {
      this.classList.remove('open-content');
      super.close(evt);
      setTimeout(() => {
        this.productElement.innerHTML = '';
      }, 300);
    }

    open(opener) {
      this.assignProductElement();
      this.configureCartAddOnAction(opener);
      this.syncDeviceModal();
      super.open(opener);
      setTimeout(() => {
        this.classList.add('open-content');
      }, 300);
    }

    initializeCallbackUtility() {
      this.postProcessHtmlCallbacks.push((newNode) => {
        this.runAfterUpdateHtml();
      });
    }

    runAfterUpdateHtml() {
      this.productElement = this.querySelector('.quick-add-main-product');
      window?.Shopify?.PaymentButton?.init();
      window?.ProductModel?.loadShopifyXR();
      this.removeDOMElements();
      this.removeGalleryListSemantic();
      this.syncDeviceModal();
    }

    syncDeviceModal() {
      const isDevice = this.productElement?.dataset.deviceModal === 'true';
      this.classList.toggle('bc-device-modal', isDevice);
      const heading = this.querySelector('.drawer__heading');
      if (isDevice && heading) heading.textContent = this.productElement.dataset.deviceHeading;
      const dialog = this.querySelector('[role="dialog"]');
      if (dialog && heading) dialog.setAttribute('aria-label', heading.textContent.trim());
    }

    assignProductElement() {
      if(!this.productElement || !this.productElement.parentNode) {
        this.productElement = this.querySelector('.quick-add-main-product');
      }
    }

    setInnerHTML(newQuickAddDrawer) {
      this.assignProductElement();
      const newProductElement = newQuickAddDrawer.querySelector('.quick-add-main-product');
      HTMLUpdateUtility.viewTransition(this.productElement, newProductElement, [], this.postProcessHtmlCallbacks);
    }

    reInjectScript(element) {
      HTMLUpdateUtility.reinjectsScripts(element);
    }
    
    removeDOMElements() {
      this.productElement.querySelectorAll('.quick-add-hidden').forEach(element => {
        if(element) {
          element.remove();
        }
      });
    }

    configureCartAddOnAction(opener) {
      const productForm = this.productElement.querySelector('product-form');
      const heading = this.querySelector('.drawer__heading');
      this.classList.remove('quick-add-drawer--cart-add-on');
      if (heading?.dataset.defaultLabel) heading.textContent = heading.dataset.defaultLabel;
      const action = opener?.dataset.cartAddOnAction;
      if (!productForm || !['add', 'replace'].includes(action)) return;

      productForm.dataset.cartAddOnAction = action;
      productForm.dataset.cartAddOnParentKey = opener.dataset.cartAddOnParentKey;
      if (action === 'replace') {
        productForm.dataset.cartAddOnKey = opener.dataset.cartAddOnKey;
        productForm.dataset.cartAddOnVariantId = opener.dataset.cartAddOnVariantId;
        productForm.dataset.cartAddOnQuantity = opener.dataset.cartAddOnQuantity;
        productForm.dataset.cartAddOnCurrentQuantity = opener.dataset.cartAddOnQuantity;
        productForm.dataset.cartAddOnMatchParentQuantity = opener.dataset.cartAddOnMatchParentQuantity;
        productForm.dataset.cartAddOnDisplayName = opener.dataset.cartAddOnDisplayName;
        productForm.dataset.cartAddOnHeadingLabel = opener.dataset.cartAddOnHeadingLabel;
        productForm.dataset.cartAddOnUpdateLabel = opener.dataset.cartAddOnUpdateLabel;
        this.trackCartAddOnQuantity(productForm);
      } else {
        productForm.dataset.cartAddOnParentQuantity = opener.dataset.cartAddOnParentQuantity;
        productForm.dataset.cartAddOnExistingProductIds = opener.dataset.cartAddOnExistingProductIds;
        productForm.dataset.cartAddOnAddLabel = opener.dataset.cartAddOnAddLabel;
      }
      this.classList.add('quick-add-drawer--cart-add-on');
      this.applyCartAddOnAction();
    }

    applyCartAddOnAction() {
      const productForm = this.productElement.querySelector('product-form[data-cart-add-on-action]');
      if (!productForm) return;

      if (productForm.dataset.cartAddOnAction === 'add') {
        this.applyCartAddOnAddAction(productForm);
        return;
      }

      this.productElement.querySelector('[id^="ProductAddOns-"]')?.remove();
      this.productElement.querySelector('.shopify-payment-button')?.remove();
      this.productElement.querySelectorAll('variant-radios, variant-selects').forEach((picker) => picker.remove());
      this.productElement.querySelector('[data-cart-add-on-picker]')?.removeAttribute('hidden');
      this.hideCartAddOnHeaderPrice();

      const headingLabel = productForm.dataset.cartAddOnHeadingLabel;
      const updateLabel = productForm.dataset.cartAddOnUpdateLabel;
      const heading = this.querySelector('.drawer__heading');
      const submitButton = productForm.querySelector('[name="add"]');
      if (headingLabel && heading) heading.textContent = headingLabel;
      if (updateLabel && submitButton && !submitButton.disabled) {
        submitButton.querySelector('span').textContent = updateLabel;
      }
      this.syncCartAddOnPicker(productForm);
      this.trackCartAddOnQuantity(productForm);
    }

    applyCartAddOnAddAction(productForm) {
      this.productElement.querySelectorAll('variant-radios, variant-selects, [data-cart-add-on-picker], .shopify-payment-button').forEach(
        (element) => element.remove()
      );

      const existingProductIds = new Set(
        (productForm.dataset.cartAddOnExistingProductIds || '').split(',').filter(Boolean)
      );
      const productAddOns = productForm.querySelector('product-add-ons');
      productAddOns?.querySelectorAll('[data-add-on-group]').forEach((group) => {
        if (existingProductIds.has(group.dataset.addOnProductId)) group.remove();
      });

      const quantityInput = productForm.querySelector('input[name="quantity"]');
      const parentQuantity = productForm.dataset.cartAddOnParentQuantity || '1';
      if (quantityInput) {
        quantityInput.value = parentQuantity;
        quantityInput.closest('.product-form__quantity')?.setAttribute('hidden', '');
      }
      productForm.querySelector('.quantity__label')?.setAttribute('hidden', '');
      if (productAddOns) productAddOns.dataset.parentQuantity = parentQuantity;
      productAddOns?.updateOptionTransitions();
      productAddOns?.updateDisplayPrices();
      productAddOns?.updateSubtotal();

      const addLabel = productForm.dataset.cartAddOnAddLabel;
      const heading = this.querySelector('.drawer__heading');
      const submitButton = productForm.querySelector('[name="add"]');
      submitButton?.removeAttribute('disabled');
      submitButton?.removeAttribute('data-pre-order');
      if (addLabel && heading) heading.textContent = addLabel;
      if (addLabel && submitButton) {
        submitButton.querySelector('span').textContent = addLabel;
      }
    }

    setCartAddOnQuantity(productForm) {
      const input = productForm.querySelector('input[name="quantity"]');
      if (!input) return;

      const min = Math.max(parseInt(input.dataset.min || input.min || '1'), 1);
      const parsedMax = parseInt(input.dataset.max || '');
      const max = Number.isNaN(parsedMax) ? null : parsedMax;
      const step = Math.max(parseInt(input.step || '1'), 1);
      const currentQuantity = parseInt(productForm.dataset.cartAddOnCurrentQuantity || '');
      const cartQuantity = parseInt(productForm.dataset.cartAddOnQuantity || '');
      const isValidQuantity = (quantity) => (
        Number.isInteger(quantity)
        && quantity >= min
        && (max === null || quantity <= max)
        && (quantity - min) % step === 0
      );
      let quantity = min;

      if (isValidQuantity(currentQuantity)) quantity = currentQuantity;
      else if (isValidQuantity(cartQuantity)) quantity = cartQuantity;

      input.value = quantity;
      productForm.dataset.cartAddOnCurrentQuantity = quantity;
    }

    disableMatchedParentQuantity(productForm) {
      if (productForm.dataset.cartAddOnMatchParentQuantity !== 'true') return;

      const input = productForm.querySelector('input[name="quantity"]');
      if (!input) return;

      input.disabled = true;
      input.closest('.product-form__quantity')?.setAttribute('hidden', '');
      productForm.querySelector('.quantity__label')?.setAttribute('hidden', '');
    }

    hideCartAddOnHeaderPrice() {
      this.productElement.querySelector('[id^="price-"]')?.setAttribute('hidden', '');
      this.productElement.querySelector('.quick-add__information .product__tax')?.setAttribute('hidden', '');
      this.productElement.querySelector('.quick-add__information .installment')?.parentElement?.setAttribute('hidden', '');
    }

    updateCartAddOnOptionPrices(productForm) {
      const parsedQuantity = parseInt(
        productForm.dataset.cartAddOnCurrentQuantity
        || productForm.dataset.cartAddOnQuantity
        || '1'
      );
      const quantity = Number.isNaN(parsedQuantity) ? 1 : Math.max(parsedQuantity, 1);

      this.productElement.querySelectorAll('[data-cart-add-on-picker] [data-add-on-display-price]').forEach((priceElement) => {
        const unitPrice = parseInt(priceElement.dataset.addOnUnitPrice || '0');
        priceElement.innerHTML = Shopify.formatMoney(unitPrice * quantity, window.moneyFormat);
      });
    }

    syncCartAddOnPicker(productForm) {
      const picker = this.productElement.querySelector('[data-cart-add-on-picker] product-add-on-picker');
      const selectedVariant = picker?.querySelector('.product-add-ons__input[data-add-on-variant-id]');
      const variantInput = productForm.querySelector('.product-variant-id');
      const submitButton = productForm.querySelector('[name="add"]');
      if (!picker || !variantInput || !submitButton) return;

      if (!selectedVariant) {
        variantInput.disabled = true;
        submitButton.disabled = true;
        submitButton.querySelector('span').textContent = window.variantStrings.unavailable;
        return;
      }

      variantInput.value = selectedVariant.dataset.addOnVariantId;
      variantInput.disabled = false;
      productForm.dataset.cartAddOnLabel = this.createCartAddOnLabel(
        productForm.dataset.cartAddOnDisplayName,
        selectedVariant.dataset.addOnVariantTitle
      );
      submitButton.disabled = false;
      submitButton.removeAttribute('data-pre-order');
      this.updateCartAddOnQuantityRules(productForm, selectedVariant);
      this.setCartAddOnQuantity(productForm);
      this.disableMatchedParentQuantity(productForm);
      this.updateCartAddOnOptionPrices(productForm);

      const updateLabel = productForm.dataset.cartAddOnUpdateLabel;
      if (updateLabel) submitButton.querySelector('span').textContent = updateLabel;
    }

    createCartAddOnLabel(displayName, variantTitle) {
      if (!variantTitle || variantTitle === 'Default Title') return displayName;
      return `${displayName} (${variantTitle})`;
    }

    updateCartAddOnQuantityRules(productForm, selectedVariant) {
      const input = productForm.querySelector('input[name="quantity"]');
      if (!input) return;

      const min = selectedVariant.dataset.addOnQuantityMin || '1';
      const increment = selectedVariant.dataset.addOnQuantityIncrement || '1';
      const max = selectedVariant.dataset.addOnQuantityMax;
      input.min = min;
      input.dataset.min = min;
      input.step = increment;
      if (max) {
        input.max = max;
        input.dataset.max = max;
      } else {
        input.removeAttribute('max');
        delete input.dataset.max;
      }
    }

    trackCartAddOnQuantity(productForm) {
      const input = productForm.querySelector('input[name="quantity"]');
      if (!input || input.dataset.cartAddOnQuantityTracked === 'true') return;

      const updateCurrentQuantity = () => {
        productForm.dataset.cartAddOnCurrentQuantity = input.value;
        this.updateCartAddOnOptionPrices(productForm);
      };
      input.dataset.cartAddOnQuantityTracked = 'true';
      input.addEventListener('input', updateCurrentQuantity);
      input.addEventListener('change', updateCurrentQuantity);
    }

    onVariantChanged(event) {
      if (!this.contains(event.target) && event.detail.sectionId !== this.productElement?.dataset.section) return;
      this.applyCartAddOnAction();
    }

    onAddOnPickerVariantChanged(event) {
      const productForm = this.productElement?.querySelector('product-form[data-cart-add-on-action="replace"]');
      if (!productForm || !this.contains(event.target)) return;
      this.syncCartAddOnPicker(productForm);
    }

    removeGalleryListSemantic() {
      const galleryList = this.productElement.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}

